import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Container from "../../componentes/Container";
import { CampoDeTexto } from "../../componentes";
import Paginacao from "../GerenciarPermissoesLocaisAtendimento/components/Paginacao";
import "./styles.scss";
import { buscarProjetos } from "./services/buscarProjetos";
import { useHistory } from "react-router-dom";
import { BotaoComTextoEIcone } from "@digix-ui/componentes";

const ListagemProjetos = () => {
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroPrograma, setFiltroPrograma] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const history = useHistory();

  const { data, isLoading, error } = useQuery({
    queryKey: ["projetos", filtroNome, filtroPrograma, paginaAtual],
    queryFn: () =>
      buscarProjetos(
        filtroNome,
        filtroPrograma ? Number(filtroPrograma) : undefined,
        paginaAtual
      ),
  });

  function irParaPagina(pagina: number) {
    if (pagina <= 0) return;
    if (data && pagina > data.totalDePaginas) return;
    setPaginaAtual(pagina);
  }

  const colunas = ["Projeto", "Programa", "Data de início", "Data de fim", ""];

  return (
    <>
      <Container comFundo tamanhoDoContainer="grande" comCabecalhoFixo>
        <div className="formulario">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "0.5rem",
              width: "100%",
            }}
          >
            <h2
              className="cartao__titulo u-texto-negrito"
              style={{ margin: 0 }}
            >
              Projetos
            </h2>
            <div style={{ marginLeft: "auto" }}>
              <BotaoComTextoEIcone
                tipo="button"
                cor="sucesso"
                tamanho="pequeno"
                icone="fas fa-plus"
                posicaoDoIcone="esquerda"
                onClick={() => (window.location.href = "/projeto/criar")}
              >
                Cadastrar novo Projeto
              </BotaoComTextoEIcone>
            </div>
          </div>
          <p className="u-texto-pequeno u-margem-top-pequena">
            Gerencie quais projetos estão em vigor no momento. Você pode
            editá-los conforme necessário.
          </p>
          <div className="grade__linha u-margem-superior-media">
            <CampoDeTexto
              name="filtroNome"
              label="Busque por projeto"
              value={filtroNome}
              onChange={(e) => {
                setFiltroNome(e.target.value);
                irParaPagina(1);
              }}
              onBlur={() => {}}
              placeholder="Busque por projeto"
              colunas="4"
            />
            <div className="campo-de-texto u-coluna-4 filtro-programa__select">
              <label className="campo-de-texto__rotulo">
                Filtrar por programa
              </label>
              <select
                value={filtroPrograma}
                onChange={(e) => {
                  setFiltroPrograma(e.target.value);
                  irParaPagina(1);
                }}
                className="campo-de-texto__input"
              >
                <option value="">Todos</option>
                <option value="1">MS CIDADÃO CASA DA GENTE</option>
              </select>
            </div>
          </div>

          <table className="tabela tabela_com-largura-total tabela_listrada tabela_com-borda u-margem-superior-media">
            <thead>
              <tr>
                {colunas.map((coluna, idx) => (
                  <th key={idx} className="u-texto-alinhado-ao-centro">
                    {coluna}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                [...Array(5)].map((_, i) => (
                  <tr key={i}>
                    {colunas.map((_, j) => (
                      <td key={j}>
                        <div className="skeleton skeleton-linha" />
                      </td>
                    ))}
                  </tr>
                ))
              ) : error ? (
                <tr>
                  <td
                    colSpan={colunas.length}
                    className="u-texto-alinhado-ao-centro u-cor-vermelha"
                  >
                    Ocorreu um erro ao carregar os dados.
                  </td>
                </tr>
              ) : data?.modelo.length === 0 ? (
                <tr>
                  <td
                    colSpan={colunas.length}
                    className="u-texto-alinhado-ao-centro"
                  >
                    Nenhum projeto encontrado.
                  </td>
                </tr>
              ) : (
                data?.modelo.map((projeto) => (
                  <tr key={projeto.id}>
                    <td>{projeto.nome}</td>
                    <td className="u-texto-alinhado-ao-centro">
                      {projeto.programa}
                    </td>
                    <td className="u-texto-alinhado-ao-centro">
                      {projeto.dataInicio}
                    </td>
                    <td className="u-texto-alinhado-ao-centro">
                      {projeto.dataFim}
                    </td>
                    <td className="u-texto-alinhado-ao-centro">
                      <button
                        className="botao-editar"
                        onClick={() =>
                          history.push(`/projeto/editar/${projeto.id}`)
                        }
                      >
                        <i
                          className="fa fa-pencil-alt icone-editar"
                          aria-hidden="true"
                        ></i>
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {data && (
            <>
              <div className="u-margem-top-media u-texto-pequeno">
                {data.totalDeRegistros} resultado(s)
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "1rem",
                }}
              >
                <Paginacao
                  paginaAtual={paginaAtual}
                  totalDePaginas={data.totalDePaginas}
                  onPageChange={irParaPagina}
                />
              </div>
            </>
          )}
        </div>
      </Container>
    </>
  );
};

export default ListagemProjetos;
